'use strict';

var React = require('react');

var SvgPasskeyMajor = function SvgPasskeyMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9 3a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7Zm-2 3.5a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.827 14.955a4.773 4.773 0 0 1 4.173-2.455.75.75 0 0 0 0-1.5 6.273 6.273 0 0 0-5.484 3.227l-.437.786a1.338 1.338 0 0 0 1.17 1.987h6.001a.75.75 0 0 0 0-1.5h-5.725l.302-.545Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.125 12.5a.875.875 0 1 0 0-1.75.875.875 0 0 0 0 1.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M17.674 14.875a2.348 2.348 0 0 0 1.076-1.975v-1.275a3.625 3.625 0 0 0-7.25 0v1.275c0 .9.506 1.683 1.25 2.077v1.874a2 2 0 0 0 .327 1.095l.422.645a2 2 0 0 0 2.988.411l.553-.482a2 2 0 0 0 .494-2.362c.189-.395.242-.85.14-1.283Zm-3.471-.914a.4.4 0 0 0-.353-.211.85.85 0 0 1-.85-.85v-1.275a2.125 2.125 0 0 1 4.25 0v1.275c0 .47-.38.85-.85.85h-.218a.5.5 0 0 0-.5.5v.072a.5.5 0 0 0 .113.316l.331.405a.439.439 0 0 1 .093.206.437.437 0 0 1-.266.474.439.439 0 0 0-.11.742l.198.16a.5.5 0 0 1 .012.765l-.552.482a.5.5 0 0 1-.747-.102l-.422-.645a.5.5 0 0 1-.082-.274v-2.701a.399.399 0 0 0-.047-.19Z"
  }));
};
SvgPasskeyMajor.displayName = "PasskeyMajor";

exports.SvgPasskeyMajor = SvgPasskeyMajor;
